module.exports = __webpack_public_path__ + "static/the-plant-paradox-95dd769c0c2f5f2e5f8533f864c508f0.jpg";